import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { Observable, combineLatest, of } from 'rxjs';
import { filter, repeat, switchMap, take } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';

import { AppState } from '../../reducers';
import { isLoggedIn, getUserRole, loadingUserInProgress } from '../_selectors/auth.selectors';
import { NotificationService } from '@core/services';

@Injectable()
export class RoleGuard {
  private notificationService = inject(NotificationService);
  private store = inject(Store<AppState>);
  private router = inject(Router);

  canActivate(routeSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const allowedRoles: string[] = Array.isArray(routeSnapshot.data['roles']) ? routeSnapshot.data['roles'] : [];
    return combineLatest([
      this.store.pipe(select(isLoggedIn)),
      this.store.pipe(select(getUserRole)),
      this.store.pipe(select(loadingUserInProgress)),
    ]).pipe(
      repeat({ delay: 250, count: 10 }),
      filter(([, , loadingUserInProgress]) => !loadingUserInProgress),
      take(1),
      switchMap(([loggedIn, userRole]) => {
        if (!loggedIn || !userRole) {
          this.router.navigateByUrl('/auth/login');
          return of(false);
        }

        if (!allowedRoles.length || allowedRoles.includes(userRole)) {
          return of(true);
        }

        this.notificationService.showError(`You do not have permission to view this page`);
        this.router.navigateByUrl('/');
        return of(false);
      }),
    );
  }
}
